/**
 * Generated by '@kontent-ai/model-generator@6.5.1'
 */
export const webhooks = {} as const;
